<div class="flex flex-row w-full justify-between">
  <div class="flex flex-col">
    <div class="soft-overline">
      {{ 'Aufgaben' | translate }}
    </div>
    <div class="text-xs text-light">
      {{ zeitraum().from | format: 'DATE.DEFAULT' }} -
      {{ zeitraum().to | format: 'DATE.DEFAULT' }}
    </div>
  </div>

  <div class="flex flex-row gap-3">
    @if (date(); as date) {
      <div class="flex flex-row flex-nowrap gap-4 justify-center items-center">
        <div
          class="w-8 h-8 pointer flex flex-row justify-center items-center"
          (click)="onDateChange(date, -1)"
        >
          <soft-icon name="fa-regular fa-chevron-left"></soft-icon>
        </div>
        <div
          class="w-8 h-8 pointer flex flex-row justify-center items-center hover:underline"
          (click)="onDateChange(dateService.now(), 0)"
        >
          {{ '#UI_CORE.COMPONENTS.DATE_NAVIGATOR.TODAY' | translate }}
        </div>
        <div
          class="w-8 h-8 pointer flex flex-row justify-center items-center"
          (click)="onDateChange(date, 1)"
        >
          <soft-icon name="fa-regular fa-chevron-right"></soft-icon>
        </div>
      </div>
    }
    <soft-icon
      class="self-center text-accent-700 cursor-pointer"
      [name]="'fa-regular fa-up-right-from-square'"
      [routerLink]="['/aufgaben']"
      [queryParams]="{ query: queryString(), origin: currentUrl() }"
    ></soft-icon>
  </div>
</div>

<div class="mt-2">
  <soft-resource-container [resource]="checklistResource">
    <div
      class="flex flex-col xs:flex-row gap-3"
      [ngClass]="checklistData().data.length < 1 ? 'xs:items-center' : 'xs:items-start'"
    >
      <div
        class="flex flex-col items-center self-center gap-1 justify-center shrink-0 min-w-[192px]"
        [ngClass]="gaugeMaxWidth()"
      >
        <soft-donut-chart
          size="w-48 h-48"
          [segments]="[
            {
              label: 'Erledigt',
              color: 'var(--colorSuccess500)',
              value:
                (checklistData()?.countAll ?? 0) - (checklistData()?.countOnlyOpen ?? 0),
            },
            {
              label: 'Offen',
              color: 'var(--colorSurfaceTertiary)',
              value: checklistData()?.countOnlyOpen ?? 0,
            },
          ]"
        >
          <span class="text-xl font-semibold">
            {{ checklistData().countAll - checklistData().countOnlyOpen }} von
            {{ checklistData().countAll }}
          </span>
        </soft-donut-chart>

        <div class="flex text-center items-center justify-center gap-4">
          <div class="flex gap-2 items-center">
            <span class="size-3 inline-block rounded bg-surface-tertiary"></span>
            <span class="text-xs">Offen</span>
          </div>
          <div class="flex gap-2 items-center">
            <span class="size-3 inline-block rounded bg-success-500"></span>
            <span class="text-xs">Erledigt</span>
          </div>
        </div>
      </div>

      <ul class="flex flex-col w-full">
        @for (todo of checklistData().data | slice: 0 : 7; track todo.id) {
          <li
            class="py-2 px-2 hover:bg-hover text-sm w-full cursor-pointer"
            [class.border-b]="!$last"
            [routerLink]="['/aufgaben', todo.id]"
            [queryParams]="{ query: queryString() }"
          >
            {{ todo.betreff }}
          </li>
        } @empty {
          <div class="py-5 w-full flex flex-col items-center text-center justify-center">
            <soft-icon name="memo-circle-check text-xl text-lighter"></soft-icon>
            <span class="text-sm font-semibold">Alles erledigt!</span>
            <span class="text-sm text-lighter">Sie haben alle Aufgaben erledigt :)</span>
          </div>
        }
      </ul>
    </div>
  </soft-resource-container>
</div>
